'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoMicroscope = function GoMicroscope(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.1 35c3.4-0.7 5.9-3.9 5.9-7.5 0-2.3-1-4.3-2.6-5.7 0-0.6 0.1-1.2 0.1-1.8 0-4.1-1.9-7.7-5-10l2.5-2.5v-2.5l2.5-2.5-2.5-2.5-2.5 2.5h-2.5l-10 10-5 2.5v5l2.5 2.5h5l2.5-5 3.8-3.7c2.1 1.3 3.7 3.5 3.7 6.2-4.1 0-7.5 3.4-7.5 7.5h-15v2.5h7.5c0.7 0.6 1.6 0.9 2.5 1.3v3.7h-5l-5 5h30l-5-5h-0.9z m-4.1-7.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5z' })
        )
    );
};

exports.default = GoMicroscope;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/microscope.js
// module id = 1945
// module chunks = 0